import SiteImportBLController from './site.import.bl.controller';

export default {
    bindings: {
        site: '='
    },
    template: require('./site.import.bl.html'),
    controller: SiteImportBLController
};
